import AxiosInstance from "../Utils/axios/axiosConfig";

export const getCustomers = async (params) => {
  let response;
  if (params) {
    if (params.page && params.size && params.sort_by && params.sort_type) {
      const start = (params.page - 1) * params.size;
      const end = start + params.size * 1;
      response = await AxiosInstance.get(
        `/customers/?sort_by=${params.sort_by}&sort_type=${params.sort_type}&start=${start}&end=${end}`
      );
    } else if (params.status)
      response = await AxiosInstance.get(`/customers/?status=${params.status}`);
  } else response = await AxiosInstance.get("/customers/");

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getCustomersForConfiguration = async (params, source = undefined) => {
  let response;
  if (params) {
    if (params.page && params.size && params.sort_by && params.sort_type) {
      const start = (params.page - 1) * params.size;
      const end = start + params.size * 1;
      response = await AxiosInstance.get(
        `/crud/customers/?sort_by=${params.sort_by}&sort_type=${params.sort_type}&start=${start}&end=${end}`
      );
    } else if (params.status)
      response = await AxiosInstance.get(`/crud/customers/?status=${params.status}`);
  } else{ 
    if(source){
      response = await AxiosInstance.get("/crud/customers/", {cancelToken: source?.token});
    } else{
      response = await AxiosInstance.get("/crud/customers/");
    }
}
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const addNewCustomer = async (body) => {
  const response = await AxiosInstance.post("/crud/customers/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getCustomerDetails = async (code = "") => {
  const response = await AxiosInstance.get("/crud/customers/", {
    params: { code: code },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const editCustomer = async (code = "", body = {}) => {
  const response = await AxiosInstance.put(`/crud/customers/?code=${code}`, body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const deleteCustomer = async (code = "") => {
  const response = await AxiosInstance.delete(`/crud/customers/?code=${code}`);
  return response.data;
};

// Search Customer list
export const searchCustomers = async (pattern = "", params = {}, source = undefined) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  let response;
  if(!params.size && !params.page){
    response = await AxiosInstance.get("/crud/customers/?search", {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
      },
    });
  } else{
    if(source){
      response = await AxiosInstance.get("/crud/customers/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          sort_by: params.sort_by,
          sort_type: params.sort_type,
          start: start,
          end: end,
        },
        cancelToken: source?.token
      });
    } else{
      response = await AxiosInstance.get("/crud/customers/?search", {
        params: {
          type: "contains",
          pattern: pattern,
          sort_by: params.sort_by,
          sort_type: params.sort_type,
          start: start,
          end: end,
        },
      });
    }
  }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

// export const getFilteredCustomers = async (sort, filter, source = undefined,searchedValue) => {
//   if (sort) {
//     const start = (sort.page - 1) * sort.size;
//     const end = start + sort.size * 1;
//     const response = await AxiosInstance.post(
//       `/crud/customers/filter/?sort_by=${sort.sort_by}&sort_type=${sort.sort_type}&start=${start}&end=${end}`,
//       filter
//     );
//     if (!response.data.error) {
//       return response.data;
//     } else {
//       return Promise.reject(response);
//     }
//   } else {
//     let response;
//     if(source){
//       response = await AxiosInstance.post(`/crud/customers/filter/`, filter, {cancelToken: source?.token});
//     } else{
//       response = await AxiosInstance.post(`/crud/customers/filter/`, filter);
//     }
//     if (!response.data.error) {
//       return response.data;
//     } else {
//       return Promise.reject(response);
//     }
//   }
// };

export const getFilteredCustomers = async (sortParams, filter, source = undefined, searchedValue) => {
  let response;
  let url = `/crud/customers/filter/`;

  // Add search if provided
  if (searchedValue) {
    url += `?search&type=contains&pattern=${encodeURIComponent(searchedValue)}`;
  } else {
    url += `?`;
  }

  // Add sorting + pagination if sortParams present
  if (sortParams) {
    const start = (sortParams.page - 1) * sortParams.size;
    const end = start + sortParams.size;

    url += `&sort_by=${sortParams.sort_by}&sort_type=${sortParams.sort_type}&start=${start}&end=${end}`;
  }

  // Make request
  if (source) {
    response = await AxiosInstance.post(url, filter, { cancelToken: source?.token });
  } else {
    response = await AxiosInstance.post(url, filter);
  }

  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};


export const getCountries = () => {
  return AxiosInstance.get(`/customers/?country`);
};
export const getCustomerHistoryById = async (code,sort) => {
  const start = (sort.page - 1) * sort.size;
  const end = start + sort.size * 1;
  const response = await AxiosInstance.get(`/customers/history/?code=${code}&start=${start}&end=${end}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

// change history search

export const searchCustomerHistory = async (code, pattern) => {
  const response = await AxiosInstance.get(
    `/customers/history/?code=${code}&search&type=contains&pattern=${pattern}`
    );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};